const colors = {
    cardColor: '#26262e',
    textColor: 'white',
    stripdefaultColor: '#343445',
    borderStyle: ".5px solid black",
    rawDataHightlightColor: '#7972e7',
    rawDataHightlightColorActive: "#b3f5cc"
  }

export default colors